export enum RecurrenceUpdateMode {
    Single = 'This appointment only',
    Future = 'This and future appointments',
}
